import { Message } from "iview";

const globalModules = {
  state: {
    isSdkReady: false,
    isCalling: false
  },
  getters: {
    isSdkReady: state => state.isSdkReady,
    isCalling: state => state.isCalling
  },
  mutations: {
    showToast (state, payload) {
      Message.error({
        content: payload.title,
        top: 50,
    });
    },
    setSdkReady (state, payload) {
      state.isSdkReady = payload
    },
    setCalling (state, payload) {
      state.isCalling = payload
    }
  },
  actions: {
    resetStore (context) {
      context.commit('resetGroup')
      context.commit('resetUser')
      context.commit('resetCurrentConversation')
      context.commit('resetAllConversation')
    }
  }
}

export default globalModules
